import AuthServices from '@/services/auth';
import Vue from 'vue';
import WebSocketHelper from './websocket';

Vue.use(WebSocketHelper, {
  tokenProvider: AuthServices.loadAccessToken
});

export * from './constants';
